export {
    removeDuplicatesG, isMobileG
}

//CLEAN FUNCTION(Интересно работает)
//Описание: Удаляем дубликаты из массива и возвращаем массив без дублей
//@param {array} берет масси
//@return {array} возвращает новый массив без дубликатов
function removeDuplicatesG(arr) {
    const result = [];
    const titles = new Set(); // Создаем пустой Set для хранения уникальных titles
    // Итерируемся по массиву и добавляем объект в результирующий массив, только если его title не был добавлен ранее в Set
    arr.forEach(obj => {
    if (!titles.has(obj.shikimori_id)) {
        result.push(obj);
        titles.add(obj.shikimori_id);
    }
    });
    return result;
}

function isMobileG() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
       return true
    } else {
       return false
    }
  }